import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_PRE013_Request,
  IAPI_PRE013_Response,
  IAPI_PRE016_Request,
  IAPI_PRE016_Response,
  IAPI_APP016_Request,
  IAPI_APP016_Response,
} from "../../../type/apiType";

// 納付掛金の確認表示
// API仕様書_掛金
const httpAPI_PRE013 = async (
  param: IAPI_PRE013_Request
): Promise<IAPI_PRE013_Response> => {
  let res = await http.post(ApiUrl.API_PRE013, {
    ...param,
  });
  return res.data;
};

// 掛金確定後職員情報修正納付額更新
// 掛金
const httpAPI_PRE016 = async (
  param: IAPI_PRE016_Request
): Promise<IAPI_PRE016_Response> => {
  let res = await http.post(ApiUrl.API_PRE016, {
    ...param,
  });
  return res.data;
};

// 申請状況更新
const httpAPI_APP016 = async (
  param: IAPI_APP016_Request
): Promise<IAPI_APP016_Response> => {
  let res = await http.post(ApiUrl.API_APP016, {
    ...param,
  });
  return res.data;
};

export { httpAPI_PRE013, httpAPI_PRE016, httpAPI_APP016 };
